import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {UserTagProvider} from "../../providers/user-tag/user-tag";

/**
 * Generated class for the UserContentTextareaComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'user-content-textarea',
  templateUrl: 'user-content-textarea.html'
})
export class UserContentTextareaComponent {

  @Input() prefix: string;
  @Input() value: string;
  @Input() placeholder: string;
  @Output() valueUpdated = new EventEmitter<string>();
  initText: string;

  constructor(private elementRef: ElementRef, private tag: UserTagProvider, ) {
  }

  moveCaretToEnd(el) {
    if (typeof el.selectionStart == "number") {
      el.selectionStart = el.selectionEnd = el.value.length;
    } else if (typeof el.createTextRange != "undefined") {
      el.focus();
      var range = el.createTextRange();
      range.collapse(false);
      range.select();
    }
  }


  ngAfterViewInit() {
    var me = this;
    if(me.value) {
      this.elementRef.nativeElement.firstChild.innerHTML = me.value;
      console.log(this.elementRef.nativeElement.innerHTML);
    }
    let handler  = function(el) {
      if(!me.initText) {
        me.initText = el.innerHTML;
      }

      if(el.innerHTML == "<br>") {
        el.innerHTML = '';
      }

      setTimeout(function() {
        if(window.getSelection().anchorOffset == 0) {
          console.log('move caret');
          // document.getSelection().removeAllRanges();
          // me.moveCaretToEnd(el)
        }
      }, 10);

      // if(el.innerHTML.indexOf('<span class="init-phrase" contenteditable="false">'+me.tag.compile(me.prefix, {})+'</span>') !=- 0) {
      //   el.innerHTML = el.innerHTML.replace('<span class="init-phrase" contenteditable="false">'+me.tag.compile(me.prefix, {})+'</span>','');
      //   el.innerHTML = '<span class="init-phrase" contenteditable="false">'+me.tag.compile(me.prefix, {})+'</span>' + el.innerHTML;
      //   document.getSelection().removeAllRanges();
      //   me.moveCaretToEnd(el)
      // }

      me.value = el.innerHTML;
      me.valueUpdated.emit(me.value);
    }

    this.elementRef.nativeElement.firstChild.addEventListener('click', function() {
      handler(this);
    })
    this.elementRef.nativeElement.firstChild.addEventListener('input', function() {
      handler(this);
    })
    this.elementRef.nativeElement.firstChild.addEventListener('keydown', function() {
      handler(this);
    })
    this.elementRef.nativeElement.firstChild.addEventListener('focus', function(e) {
      handler(this);
    })
  }

  textUpdated(e) {
    console.log(e);
  }

}



// WEBPACK FOOTER //
// ./src/components/user-content-textarea/user-content-textarea.ts